module.exports = __webpack_public_path__ + "static/media/html5.0ffb96b4.png";